import { makeStyles } from "tss-react/mui";
import { LinkedExtended } from "@miplatform/assets";
import {
  IBidArea,
  IBidAreaMaterial,
  IMaterialsResponse,
} from "@miplatform/types";
import { QuantityField } from "@mibuildweb/components";
import { Box, Collapse, Divider } from "@mui/material";
import { ThinMaterialCard } from "../../../../../components/MaterialCard/ThinMaterialCard";

export function BidMaterial({
  item,
  areaMaterial,
  area,
  isLast,
  isDisabled,
  showLinkedItems,
  linkedMaterialDetails,
  menuData,
  handleUpdateItemQuantity,
}: Readonly<BidMaterialProps>) {
  const { classes, theme } = useStyles();

  return (
    <Box>
      <ThinMaterialCard
        item={item}
        isSuppliedByBuilder={areaMaterial?.suppliedByBuilder}
        showSalePrice
        cardStyle={{
          padding: theme.spacing(0, 2, 0, 0),
          borderBottom: "none",
          height: 28,
        }}
        leftAction={
          <QuantityField
            quantity={areaMaterial?.quantity}
            disabled={isDisabled}
            onChange={(qty) =>
              handleUpdateItemQuantity(
                area,
                areaMaterial?.materialId ?? "",
                qty
              )
            }
          />
        }
        menuData={menuData}
      />
      {item.linkedMaterials?.map((linked) => {
        const linkedDetail = linkedMaterialDetails.find(
          (m) => m.id === linked.materialId
        );

        return (
          <Collapse in={showLinkedItems} key={linked.materialId} unmountOnExit>
            <Box className={classes.linkedItemBox}>
              <img
                src={LinkedExtended}
                alt="linkExtendedImage"
                className={classes.linkedExtendedImg}
              />
              <ThinMaterialCard
                item={linkedDetail}
                showSalePrice
                cardStyle={{
                  padding: theme.spacing(0, 2, 0, 0),
                  borderBottom: "none",
                }}
                leftAction={
                  <QuantityField
                    quantity={linked.quantity * (areaMaterial?.quantity || 0)}
                    disabled
                  />
                }
              />
            </Box>
          </Collapse>
        );
      })}
      {!isLast && <Divider className={classes.divider} />}
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  divider: {
    width: "100%",
  },
  linkedItemBox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    height: 28,
  },
  linkedExtendedImg: {
    position: "relative",
    bottom: 16,
    left: 9,
  },
}));

interface BidMaterialProps {
  item: IMaterialsResponse;
  areaMaterial: IBidAreaMaterial | undefined;
  area: IBidArea;
  isLast: boolean;
  isDisabled: boolean;
  showLinkedItems: boolean;
  linkedMaterialDetails: IMaterialsResponse[];
  menuData: { label: string; icon: string; action: () => void }[];
  handleUpdateItemQuantity: (
    area: IBidArea,
    materialId: string,
    quantity: number
  ) => void;
}
